import { SVGIconProps } from '../types/svg';

export const Indemnisation = ({ ...props }: SVGIconProps) => (
    <svg width="50" height="51" viewBox="0 0 50 51" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.5876 32.1265C18.3046 31.5956 16.8379 31.7691 15.7141 32.5848L7.25046 38.7278L6.66306 37.9185L15.1267 31.7755C16.5318 30.7556 18.3657 30.5387 19.97 31.2025L30.4987 35.5592C31.7926 36.0946 32.41 37.5753 31.8798 38.8713C31.3578 40.1473 29.9139 40.7749 28.6248 40.2859L20.6647 37.2665L21.0194 36.3316L28.9795 39.3509C29.7616 39.6476 30.6376 39.2668 30.9543 38.4927C31.276 37.7064 30.9013 36.808 30.1164 36.4832L19.5876 32.1265Z"
            fill="#00354F"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.4219 31.2242C32.7792 30.2222 30.6756 30.3169 29.1242 31.493L25.9344 33.9114L26.5385 34.7083L29.7284 32.2899C30.8171 31.4645 32.2512 31.3153 33.4661 31.8507L28.9118 34.9145L29.47 35.7443L34.6916 32.2315C35.8145 31.4761 37.2925 31.5172 38.3714 32.332L31.2409 36.7742L31.7697 37.623L40.2326 32.3515C40.7761 32.0134 41.4809 32.0945 41.9336 32.5471C42.5257 33.1392 42.4566 34.1183 41.7873 34.6215L29.7018 43.7077C28.8626 44.3386 27.7593 44.4974 26.7762 44.1288L19.5236 41.4091C17.7523 40.7448 15.764 41.0375 14.2592 42.184L11.7424 44.1015L12.3485 44.897L14.8653 42.9794C16.0964 42.0414 17.7233 41.8019 19.1725 42.3454L26.4251 45.0651C27.7281 45.5537 29.1904 45.3433 30.3027 44.507L42.3883 35.4208C43.5436 34.5522 43.6627 32.8621 42.6407 31.84C41.8594 31.0587 40.6427 30.9187 39.7044 31.5023L39.279 31.7669L38.9925 31.548C37.662 30.5316 35.8634 30.4154 34.4219 31.2242Z"
            fill="#00354F"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.0017 13.3283C19.7986 13.8632 16.8251 17.7041 17.36 21.9072C17.895 26.1103 21.7359 29.0838 25.939 28.5489C30.142 28.0139 33.1156 24.173 32.5806 19.9699C32.0457 15.7669 28.2048 12.7933 24.0017 13.3283ZM16.368 22.0335C15.7633 17.2825 19.1245 12.941 23.8754 12.3363C28.6264 11.7316 32.9679 15.0928 33.5726 19.8437C34.1773 24.5946 30.8161 28.9362 26.0652 29.5409C21.3143 30.1456 16.9727 26.7844 16.368 22.0335Z"
            fill="#FF8A02"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.4203 18.0284C25.8285 16.7961 23.539 17.0875 22.3066 18.6793C21.0743 20.2711 21.3657 22.5606 22.9575 23.7929C24.5493 25.0253 26.8388 24.7339 28.0712 23.1421C28.2402 22.9237 28.5542 22.8838 28.7726 23.0528C28.991 23.2219 29.0309 23.5359 28.8619 23.7543C27.2914 25.7828 24.3739 26.1541 22.3453 24.5837C20.3168 23.0132 19.9455 20.0957 21.5159 18.0671C23.0864 16.0386 26.0039 15.6673 28.0325 17.2377C28.2508 17.4068 28.2908 17.7208 28.1217 17.9392C27.9527 18.1575 27.6386 18.1975 27.4203 18.0284Z"
            fill="#FF8A02"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.4467 20.2422C19.4119 19.9683 19.6057 19.718 19.8796 19.6831L23.4522 19.2284C23.7261 19.1935 23.9765 19.3873 24.0113 19.6612C24.0462 19.9352 23.8524 20.1855 23.5785 20.2204L20.0059 20.6751C19.7319 20.7099 19.4816 20.5161 19.4467 20.2422Z"
            fill="#FF8A02"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.7757 22.8268C19.7408 22.5529 19.9346 22.3025 20.2086 22.2677L23.7812 21.813C24.0551 21.7781 24.3054 21.9719 24.3403 22.2458C24.3752 22.5198 24.1814 22.7701 23.9074 22.805L20.3348 23.2597C20.0609 23.2945 19.8106 23.1007 19.7757 22.8268Z"
            fill="#FF8A02"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M41.2891 20.3656C41.3508 20.6348 41.1827 20.903 40.9136 20.9648L37.2624 21.8027C36.9933 21.8644 36.725 21.6963 36.6633 21.4272C36.6015 21.158 36.7696 20.8898 37.0388 20.828L40.6899 19.9901C40.959 19.9284 41.2273 20.0965 41.2891 20.3656Z"
            fill="#FF8A02"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.85846 26.9076C9.79669 26.6384 9.96481 26.3702 10.234 26.3084L14.0086 25.4422C14.2778 25.3804 14.546 25.5485 14.6078 25.8177C14.6696 26.0868 14.5014 26.3551 14.2323 26.4168L10.4576 27.2831C10.1885 27.3448 9.92022 27.1767 9.85846 26.9076Z"
            fill="#FF8A02"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.823 7.61104C36.057 7.75768 36.1278 8.06624 35.9812 8.30023L33.4195 12.3878C33.2729 12.6218 32.9643 12.6926 32.7303 12.5459C32.4963 12.3993 32.4255 12.0907 32.5722 11.8567L35.1338 7.7692C35.2805 7.53521 35.589 7.4644 35.823 7.61104Z"
            fill="#278BE5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.38919 13.1521C9.53583 12.9181 9.84439 12.8473 10.0784 12.994L14.1659 15.5557C14.3999 15.7023 14.4707 16.0109 14.3241 16.2448C14.1774 16.4788 13.8689 16.5496 13.6349 16.403L9.54735 13.8413C9.31336 13.6947 9.24255 13.3861 9.38919 13.1521Z"
            fill="#278BE5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.6118 9.79751C21.3425 9.85871 21.0746 9.69003 21.0134 9.42076L20.3016 6.28901C20.2404 6.01974 20.4091 5.75183 20.6784 5.69064C20.9477 5.62944 21.2156 5.79812 21.2768 6.06739L21.9885 9.19914C22.0497 9.46841 21.881 9.73632 21.6118 9.79751Z"
            fill="#FF8A02"
        />
    </svg>
);
